<template>
  <s-button @click="toggleAutoScroll">{{ autoScrollText }}</s-button>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import {
  CURRENT_USER_MUTATIONS,
  CURRENT_USER_GETTERS
} from '@/store/modules/currentuser';

export default {
  props: {
    text: {
      type: String
    }
  },
  methods: {
    ...mapMutations('currentuser', {
      $toggleAutoScroll: CURRENT_USER_MUTATIONS.TOGGLE_AUTO_SCROLL
    }),
    toggleAutoScroll() {
      this.$toggleAutoScroll();
    }
  },
  computed: {
    ...mapGetters('currentuser', {
      $autoScroll: CURRENT_USER_GETTERS.AUTO_SCROLL
    }),
    autoScrollText() {
      let text = this.$t('generic.autoScroll') + ': ';
      text += this.$autoScroll ? this.$t('generic.on') : this.$t('generic.off');
      return text;
    }
  }
};
</script>

<style></style>
